<template>
  <div>
    <nav-breadcrumb :menu="[{label :'放款复核'}]"/>
    <el-form label-width="170px" class="xzformitemmb" :model="financingDetail" ref="dataForm">
      <el-row>
        <panel title="贷款信息" border>
          <el-col :span="12">
            <el-form-item label="贷款编号 ：">
              {{financingDetail.fi__transactionNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="贷款状态：">
              {{'Financing_'+ financingDetail.fi__transactionStatus|Status2CN}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称：">
              {{financingDetail.fi__customerName}}
            </el-form-item>
            <el-form-item label="贷款金额：">
              {{financingDetail.fi__totalAmount|formatMoney}} 元
            </el-form-item>
            <el-form-item label="贷款开始日期：">
              {{financingDetail.fi__startDate|moment('YYYY-MM-DD')}}
            </el-form-item>
            <el-form-item label="贷款合同利率：">
              {{financingDetail.fi__interestRate}}% （{{financingDetail.fi__interestType|Status2CN}}）
            </el-form-item>
            <el-form-item label="还款方式：">
              {{financingDetail.fi__repaymentFormula|Status2CN}}
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="渠道商：">
              {{financingDetail.d__dealerName}}
            </el-form-item>
            <el-form-item label="贷款产品：">
              {{financingDetail.ct__productName}}
            </el-form-item>

            <el-form-item label="贷款结束日期：">
              {{financingDetail.fi__endDate|moment('YYYY-MM-DD')}}
            </el-form-item>

            <el-form-item label="留存收益率：">
              {{financingDetail.dfi__interestRate}}% （{{financingDetail.dfi__interestType|Status2CN}}）
            </el-form-item>
            <el-form-item label="还款期数（月）：">
              {{financingDetail.fi__repaymentCount}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="贷款用途：">
              {{financingDetail.fi__intendedUse}}
            </el-form-item>
          </el-col>
        </panel>
        <panel title="放款信息" border>
          <el-col :span="12">
            <el-form-item label="收款账号：">
              {{financingDetail.pay__customerAccountNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户名：">
              {{financingDetail.pay__customerAccountName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行：">
              {{financingDetail.pay__customerAccountBankName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款方式：" prop="pay__channel" >
              {{financingDetail.pay__channel|Status2CN}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请放款金额：">
              {{financingDetail.pay__totalAmount|formatMoney}} 元
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="申请放款日期：" prop="t__paymentDate" :rules="{required: true, message: '日期不能为空'}" >
              <el-date-picker
                v-model="financingDetail.t__paymentDate"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通联支付银行代码：" prop="t__customerBankCode" :rules="{required: true, message: '通联支付银行代码不能为空'}">
              <el-input v-model="financingDetail.t__customerBankCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通联支付账户余额：">
              {{balance|formatMoney}} 元
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="摘要：" prop="t__txUse" :rules="{required: true, message: '摘要不能为空'}">
              <el-input type="textarea" v-model="financingDetail.t__txUse" style="margin-bottom:10px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款人：">
              {{financingDetail.t__check1By}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经办时间：">
              {{financingDetail.t__check1Time|moment('YYYY-MM-DD HH:mm:ss')}}
            </el-form-item>
          </el-col>
        </panel>
        <panel>
          <sms-code :params="{pay__applicationId: financingDetail.pay__applicationId}" :api="xhr.sendAllinpaySMS" v-model="checkCode" :tips="'系统会给'+ financingDetail.t__checkPhone+'的手机发送动态验证码'"></sms-code>
        </panel>
      </el-row>
    </el-form>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSubmit('dataForm')">复核</el-button>
      <el-button plain @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {formatMoney} from "../../filters/CommonFilters";
  import bankCodeOptions from "../../utils/bankCodeOptions"
  import Panel from "../../components/Panel";
  import SmsCode from "../../components/SmsCode";
    export default {
        name: "PayFinancingTLT1",
      components: {SmsCode, Panel},
      data() {
        return {
          xhr,
          financingDetail: {
            t__customerBankCode:''
          },
          checkCode:'',
          balance:0,
        }
      },
      filters: {

        Status2CN
      },
      mounted(){
        this.getData()
        this.GetAccountBalance()
      },
      methods:{
        getData:function () {
          xhr.getViewAllinpayForApproval({
              'pay.applicationId': this.$route.query['applicationId']
            },
            res => {
              try {
                if (res.data.status == 'success') {
                  this.financingDetail = res.data.data
                  if(this.financingDetail.t__txUse){

                  }else{
                    this.financingDetail.t__txUse ='贷款'
                  }
                  bankCodeOptions.forEach((item,index)=>{
                    if(item[this.financingDetail.cb__bank.split("银行")[0]+'银行']){
                      this.financingDetail.t__customerBankCode = item[this.financingDetail.cb__bank.split("银行")[0]+'银行']
                    }
                  })
                }
              } catch (e) {

              }
            })
        },
        GetAccountBalance:function () {
          xhr.GetAccountBalance({
            },
            res => {
              try {
                if (res.data.status == 'success') {
                  this.balance = res.data.balance
                }
              } catch (e) {

              }
            })
        },
        onSubmit:function (formName) {
          this.$refs[formName].validate(valid=> {
            if (valid) {
              let onSubmitFrom = {
              }
              onSubmitFrom.pay__applicationId = this.financingDetail.pay__applicationId
              onSubmitFrom.t__paymentDate = this.financingDetail.t__paymentDate
              onSubmitFrom.t__customerBankCode = this.financingDetail.t__customerBankCode
              onSubmitFrom.t__txUse = this.financingDetail.t__txUse
              onSubmitFrom.t__checkCode = this.checkCode
              xhr.createAllinpayApproved(onSubmitFrom, res=> {
                try {
                  if (res.data.status == 'success') {

                    this.$router.push({
                      path: 'List'
                    })
                  }
                } catch (e) {
                }
              })
            }
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/PayFinancingTLT2.vue